// extracted by mini-css-extract-plugin
export var actions = "_l8-g";
export var benefitCard = "_l8-b";
export var benefitIcon = "_l8-d";
export var benefitLabel = "_l8-f";
export var benefits = "_l8-a";
export var benefitsSection = "_l8-8";
export var bodyText = "_l8-7";
export var closeButton = "_l8-2";
export var content = "_l8-3";
export var eyebrow = "_l8-4";
export var heading = "_l8-5";
export var image = "_l8-i";
export var imagePanel = "_l8-h";
export var modal = "_l8-0";
export var offerCard = "_l8-c";
export var offerIcon = "_l8-e";
export var sectionLabel = "_l8-9";
export var shell = "_l8-1";
export var title = "_l8-6";